import FundOpportunity from '../../models/FundOpportunity';

export type LifecycleStepLabel = { title: string; status?: string };

export const statusSteps: LifecycleStepLabel[] = [
  { title: 'Triage' },
  { title: 'Mandate' },
  { title: 'DD / Credit' },
  { title: 'EOI' },
  { title: 'Application' },
  { title: 'Execution' },
  { title: 'Under Management' },
  { title: 'Complete' },
];

export function getActiveStepFromStatus(status: FundOpportunity['status']): number {
  switch (status) {
    case 'NEW':
    case 'APPROVED':
      return 0;
    case 'EOI':
      return 3;
    case 'APPLICATION_OPEN':
      return 4;
    case 'UNDER_MANAGEMENT':
      return 6;
    case 'COMPLETE':
      return 7;
    default:
      return 0;
  }
}

export const lifecycleInfoBlocks = [
  {
    title: 'Triage',
    content:
      'For each new investment opportunity, Fides will qualify the sponsor and underlying property or project to determine whether the opportunity meets our standards and investors’ risk profile and appetite.',
  },
  {
    content:
      'A data room and RFI is completed by the prospective borrower, accompanied by property and financial due diligence, financial modelling, and preparation of investment papers to green light / red light the opportunity.',
  },
  {
    title: 'Mandate',
    content:
      'Commercial terms and conditions are agreed and a term sheet is executed before Fides proceeds to conduct detailed due diligence and prepare investor memoranda.',
  },
  {
    title: 'DD / Credit',
    content:
      'Fides ensures detailed due diligence and credit assessment is completed. This includes a valuation report from an independent valuer, legal due diligence, a quantity surveyor’s report (if applicable), and sponsor financial due diligence and credit checks.',
  },
  {
    title: 'EOI',
    content:
      'Once an opportunity sufficiently passes due diligence, an investment flyer is distributed to investors for non-binding expressions of interest.',
  },
  {
    title: 'Application',
    content:
      'A formal information memorandum, signed off by our trustee (Bardin Capital), is shared with interested investors. Formal investment applications are submitted via Registry Direct, followed by KYC checks.',
  },
  {
    title: 'Execution',
    content:
      'Fides coordinates legal negotiations, ensures documentation aligns with agreed terms, and manages the satisfaction of all conditions precedent ahead of financial close.',
  },
  {
    title: 'Under Management',
    content:
      'Investor allocations are finalized and the fund is actively under management. (Former lifecycle step was capital call.)',
  },
  {
    title: 'Complete',
    content: 'The opportunity is closed out: the fund lifecycle has completed.',
  },
];

export function isNewOpportunityStatus(status: FundOpportunity['status']): boolean {
  return status === 'APPROVED' || status === 'EOI';
}

export function getLifecycleStepTitle(status: FundOpportunity['status']): string {
  return statusSteps[getActiveStepFromStatus(status)].title;
}
